import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Collapse } from "reactstrap";
import { getPlans } from "../../actions/orders";
import WebsiteLogo from "../../helpers/WebsiteLogo";
import AddressForm from "./AddressForm";
import PaymentGateways from "./PaymentGateways";
import PlanDetailBox from "./PlanDetailBox";
import "./styles.css";
import { getEmployerCompanies } from "../../actions/employer";

const Checkout = () => {
  const { planId } = useParams();
  const customer = useSelector((state) => state.customer.profile);

  const [isCollapseFirst, setIsCollapseFirst] = useState(true);
  const toggleFirst = () => setIsCollapseFirst(!isCollapseFirst);

  const [isCollapseSecond, setIsCollapseSecond] = useState(false);
  const toggleSecond = () => setIsCollapseSecond(!isCollapseSecond);

  const [checkoutRes, setCheckoutRes] = useState(null);

  useEffect(() => {
    if (checkoutRes) {
      setIsCollapseFirst(false);
      setIsCollapseSecond(true);
    }
  }, [checkoutRes]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlans());
    dispatch(getEmployerCompanies(customer.id));
  }, [dispatch, customer]);

  return (
    <div className="checkout-sec">
      <div className="checkout-header">
        <Link to="/">
          <WebsiteLogo height="60" />
        </Link>
        <h3 className="text-center">Checkout Process</h3>
        <div style={{ minWidth: 150 }}></div>
      </div>

      <div className="container">
        <div className="content-sec">
          <div className="row">
            <div className="col-lg-8">
              <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingone">
                  <button
                    className="accordion-button"
                    onClick={toggleFirst}
                    type="button"
                  >
                    Billing Details
                  </button>
                </h2>
                <Collapse isOpen={isCollapseFirst} id="buying-one">
                  <div className="accordion-body">
                    <AddressForm
                      planId={planId}
                      setCheckoutRes={setCheckoutRes}
                    />
                  </div>
                </Collapse>
              </div>

              <div className="accordion-item mt-4 border-0 ">
                <h2 className="accordion-header" id="buyingtwo">
                  <button
                    className="accordion-button"
                    onClick={toggleSecond}
                    type="button"
                    disabled={!checkoutRes}
                  >
                    Payment Method
                  </button>
                </h2>
                <Collapse isOpen={isCollapseSecond} id="buying-two">
                  <div className="accordion-body">
                    <PaymentGateways checkoutResponse={checkoutRes} />
                  </div>
                </Collapse>
              </div>
            </div>

            <div className="col-lg-4">
              <div
                className="card border-0 shadow-sm rounded-4 sticky-top"
                style={{ top: "20px" }}
              >
                <div className="card-body p-4">
                  {/* Header with Icon Badge */}
                  <div className="text-center mb-4">
                    <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mb-2 fs-6 fw-semibold">
                      Selected Plan
                    </span>
                    <h4 className="fw-bold text-dark m-0">Plan Summary</h4>
                    <p className="text-muted small mt-1 mb-0">
                      Review your selected features & details
                    </p>
                  </div>

                  <hr className="my-3 border-secondary-subtle opacity-50" />

                  {/* Plan Details Content */}
                  <div className="py-2">
                    <PlanDetailBox planId={planId} />
                  </div>

                  <hr className="my-3 border-secondary-subtle opacity-50" />

                  {/* Switch Plan Action */}
                  <div className="text-center mt-3">
                    <Link
                      to={"/pricing"}
                      className="btn btn-outline-primary rounded-pill w-100 fw-medium d-inline-flex align-items-center justify-content-center gap-2 py-2 shadow-sm"
                    >
                      <i className="mdi mdi-swap-horizontal fs-5"></i>
                      <span>Choose another plan</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
